import { Injectable } from '@angular/core';
import { assign, head, remove } from 'lodash';

interface Timer {
  id: string;
  startTime: number;
  endTime: number | null;
}

/**
 * Telemetry Now
 *
 * Retrieve current point in global page timing telemetry. We use
 * performance.now() for it's high precision timer
 * @todo move from window to $window service
 * @returns {number}
 */
export function telemetryNow() {
  return window.performance.now();
}

@Injectable({ providedIn: 'root' })
class TimingService {
  _timerQueue: Timer[] = [];

  constructor() {}

  start(id: string): string {
    const startTime: number = telemetryNow();
    const endTime = null;

    this._timerQueue.push({ id, startTime, endTime });
    return randomID();
  }

  end(id: string): Timer | null {
    if (!id) {
      throw new Error('ID not defined');
    }
    const timer: Timer = head(remove(this._timerQueue, { id }));

    if (timer) {
      return <Timer>assign(timer, { endTime: telemetryNow() });
    } else {
      return null;
    }
  }

  hasTimer(id: string): boolean {
    return this._timerQueue.some((t) => t.id === id);
  }

  static buildKey(namespace: string, id: string): string {
    return [namespace, id].join('::');
  }
}

function randomID(): string {
  return parseInt(String(Math.random() * 1e6)).toString();
}

export default TimingService;
export { Timer };
